import React, { lazy } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import ChartDatasetSettings from '../../settings_sidebar/ChartDatasetSettings.jsx';
import Row from '../../../bootstrap/Row.jsx';
import { fetchJson } from '../../../../helpers/fetch.js';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { cloneDeep } from 'lodash';
import { DATASETS } from './PaymentsWidget.jsx';
import ColorPicker from '../../../common/ColorPicker/DashboardColorPicker.jsx';

import {
  monitoring_dashboard_list_calls_path
} from '~/routes';

function DatasetSettings({widgetId}) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const datasets = useSelector((state) => state.dashboard.widgets[widgetId].settings.datasets);

    const updateDatasetSetting = (key, index, value) => {
        const currentDatasets = cloneDeep(datasets)
        let dataset = {...datasets[index]};
        dataset[key] = value
        currentDatasets[index] = dataset;
        setAttribute('settings.datasets', currentDatasets);
    };

    return DATASETS.map((d, i) => (
      <fieldset key={d}>
        <Row>
          <label className="col-xs-6">
            {I18n.t("name_item")}
            <input
              type="text"
              className="form-control"
              name="name_item"
              maxLength={70}
              placeholder={I18n.t(`payment_status_${d}`)}
              value={datasets[i].name_item}
              onChange={(e) => updateDatasetSetting("name_item", i, e.target.value)}
            />
          </label>
          <label className="col-xs-6">
            {I18n.t("background_color")}
            <ColorPicker value={datasets[i].background_color} onChange={(value) => updateDatasetSetting('background_color', i, value)} />
          </label>
        </Row>
        <hr />
      </fieldset>
    ));
}

function PaymentsWidgetSettings({widgetId}) {
  const projectId = useSelector((state) => state.dashboard.projectId);
  const { data: calls } = useQuery({
    queryKey: ['paymentsWidgetCalls', projectId],
    queryFn: async () => fetchJson(monitoring_dashboard_list_calls_path({ project_id: projectId })),
    enabled: !!projectId,
  });
    return (
        <ChartDatasetSettings
            widgetId={widgetId}
            chart_settings_props={{
              additional_settings: ["call_id", "start_date", "end_date", "interval", "grip_options"],
              calls,
              interval_options: ["day", "month", "quarter", "year"]
            }}
            DatasetSettingsComponent={DatasetSettings}
        />
    )
}

export default PaymentsWidgetSettings;